import React, { useState } from "react";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import { Radio, RadioGroup, FormControlLabel, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledBox = styled(Box)({
  border: "1px solid #ccc",
  borderRadius: "4px",
});

const StyledFormControlLabel = styled(FormControlLabel)(
  ({ theme, checked }) => ({
    flex: 1,
    margin: 0,
    padding: "8px 16px",
    backgroundColor: checked ? "#7f7f7f" : "#ffffff",
    color: checked ? "white" : "black",
    fontWeight: "bold",
    textAlign: "center",
    transition: "background-color 0.2s",
    borderRight: checked ? "none" : "1px solid #ccc",
    "& .MuiRadio-root": {
      display: "none",
    },
  })
);

const TripBookingRequest = () => {
  const [value, setValue] = useState("request");

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Trip Booking Request</h3>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-xl-3">
                <div className="card request-card">
                  <div className="card-header stat-card-header">
                    <div className="stat-card-title">Requests</div>
                    <div className="stat-card-icon">
                      <i className="fa-solid fa-user-group"></i>
                    </div>
                  </div>
                  <div className="stat-card-body">
                    <div>
                      <div className="stat-card-count">0</div>
                      <div className="stat-card-label">Total Requests</div>
                    </div>
                    <div className="stat-card-today">
                      <div className="stat-card-today-count">0</div>
                      <div className="stat-card-today-label">Today</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3">
                <div className="card request-card">
                  <div className="card-header booked-card">
                    <div className="stat-card-title">Booked</div>
                    <div className="stat-card-icon">
                      <i className="fa-solid fa-user-group"></i>
                    </div>
                  </div>
                  <div className="stat-card-body">
                    <div>
                      <div className="stat-card-count">0</div>
                      <div className="stat-card-label">Total Requests</div>
                    </div>
                    <div className="stat-card-today">
                      <div className="stat-card-today-count">0</div>
                      <div className="stat-card-today-label">Today</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3">
                <div className="card request-card">
                  <div className="card-header pending-card">
                    <div className="stat-card-title">Pending</div>
                    <div className="stat-card-icon">
                      <i className="fa-solid fa-user-group"></i>
                    </div>
                  </div>
                  <div className="stat-card-body">
                    <div>
                      <div className="stat-card-count">0</div>
                      <div className="stat-card-label">Total Requests</div>
                    </div>
                    <div className="stat-card-today">
                      <div className="stat-card-today-count">0</div>
                      <div className="stat-card-today-label">Today</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3">
                <div className="card request-card">
                  <div className="card-header expire-card">
                    <div className="stat-card-title">Expired</div>
                    <div className="stat-card-icon">
                      <i className="fa-solid fa-user-group"></i>
                    </div>
                  </div>
                  <div className="stat-card-body">
                    <div>
                      <div className="stat-card-count">0</div>
                      <div className="stat-card-label">Total Requests</div>
                    </div>
                    <div className="stat-card-today">
                      <div className="stat-card-today-count">0</div>
                      <div className="stat-card-today-label">Today</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card card-custom">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-4">
                        <StyledBox>
                          <RadioGroup
                            row
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                          >
                            <StyledFormControlLabel
                              value="request"
                              control={<Radio />}
                              label="Request Date"
                              checked={value === "request"}
                            />
                            <StyledFormControlLabel
                              value="travel"
                              control={<Radio />}
                              label="Travel Date"
                              checked={value === "travel"}
                            />
                          </RadioGroup>
                        </StyledBox>
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiDatePicker
                          label="From Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDatePicker
                          label="To Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiInput
                          label={"Group Name"}
                          placeholder="Group Name"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Corporate Name"}
                          placeholder="Corporate Name"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Status"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={"Product"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label="Search By"
                          placeholder={"Supplier"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          label="Search By"
                          placeholder={"Trip ID"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        marginTop: "8px",
                      }}
                    >
                      <div className="user-button w-full">
                        <MuiButton
                          className="clear-btn "
                          label="Clear"
                          type="submit"
                        />
                        <MuiButton
                          label={"Get"}
                          className="main-btn get-btn"
                          variant="contained"
                          size="large"
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default TripBookingRequest;
